<template>
	<hr class="border-accented inline-5">
</template>
